/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './uploadVideo.defs'
export { main as default } from './uploadVideo.defs'
